import React, { useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { SRow } from '@avalara/skylab-sdk/react';
import analytics from '../../lib/analytics';
import { getRenewalDate } from '../helpers/buy-flow';
import { getSalestaxDefaultText, formatPrice } from '../../../shared/helpers';
import { costCalculator } from '../../lib/helpers';
import { selectState } from '../../selectors';
import { BlackText } from '../styled/components/thank-you';
import Resources from './thank-you/resources';
import ThankYouBanner from './thank-you/banner';
const Success = () => {
    const state = useSelector(selectState);
    const { avataxSignup: { buyComplete }, buyFlow: { salestax }, data: { abandonedSignupTracker }, } = state;
    useEffect(() => {
        window.removeEventListener('unload', abandonedSignupTracker || (() => undefined));
        analytics.page('SIGNUP_COMPLETE');
    }, []);
    const totalCost = costCalculator(state);
    return (React.createElement(BlackText, null,
        React.createElement(ThankYouBanner, { buyComplete: buyComplete }),
        React.createElement(SRow, { className: 'justify-content-center' },
            React.createElement("div", null,
                buyComplete
                    ? React.createElement(Fragment, null,
                        React.createElement("h3", { "data-ref": 'buy.signup.success.direct-to-buy.content', id: 'direct-to-buy-success', className: 'success-title alt' }, totalCost !== 0 && `Your payment method has been charged ${formatPrice(totalCost)}${getSalestaxDefaultText(salestax)}`),
                        React.createElement("h3", { "data-ref": 'buy.signup.success.subscription-renewal-content', className: 'success-title alt' }, `Your subscription will automatically renew ${getRenewalDate(new Date())}`))
                    : null,
                React.createElement(Resources, null)))));
};
export default Success;
